<template>
  <model-form
    ref="modelForm"
    :model="priceCard"
    modal-type="modal"
  >
    <div class="column">
      <div class="row">
        <model-form-input
          field="name"
          class="col"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          autofocus
        />
      </div>
      <div class="row">
        <price-card-item-table :price-card="priceCard" />
      </div>
      <div class="row">
        <q-select
          v-model="priceCard.showingBadgeIds"
          class="col"
          multiple
          bottom-slots
          :options="$_.map(showingBadges.data, 'id')"
          stack-label
          label="Showing Badges"
          :disable="priceCard.isTranslation"
        >
          <template #selected-item="scope">
            <q-chip
              :removable="!priceCard.isTranslation"
              dense
              :tabindex="scope.tabindex"
              :label="showingBadges.get(scope.opt).type === 'name' || showingBadges.get(scope.opt).type === 'name-and-icon' ? showingBadges.get(scope.opt).displayName : ''"
              :icon="showingBadges.get(scope.opt).type === 'icon' || showingBadges.get(scope.opt).type === 'name-and-icon' ? showingBadges.get(scope.opt).iconName : undefined"
              square
              @remove="scope.removeAtIndex(scope.index)"
            />
          </template>
          <template #option="scope">
            <q-item
              v-bind="scope.itemProps"
              v-on="scope.itemEvents"
            >
              <q-item-section avatar>
                <q-icon :name="showingBadges.get(scope.opt).iconName" />
              </q-item-section>
              <q-item-section>
                <q-item-label>
                  {{ showingBadges.get(scope.opt).displayName }}
                </q-item-label>
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
      <div class="row">
        <model-form-toggle
          field="overrideMaxTicketsPerOrderPerShowing"
          class="col-6 q-pb-md"
          label="Override Max Tickets Per Order Per Showing"
        />
        <model-form-input
          field="maxTicketsPerOrderPerShowing"
          :disable="!priceCard.overrideMaxTicketsPerOrderPerShowing"
          type="number"
          min="0"
          step="1"
          class="col-6"
          label="Max Tickets Per Order Per Showing"
          :rules="[val => !!val || 'Field is required']"
        />
      </div>
    </div>
  </model-form>
</template>

<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import PriceCardItemTable from 'src/modules/admin/price-card/PriceCardItemTable'

export default {
  name: 'PriceCardForm',
  components: {
    ModelForm,
    PriceCardItemTable
  },
  configuration: ['ticketTypes', 'showingBadges'],
  models: {
    priceCard: {
      editing: true,
      priceCardItems: {
        itemPackage: true,
        ticketType: true
      },
      showingBadges: true,
      libraryChildSiteIds: true
    }
  }
}

</script>
